import * as React from "react";
import type { SVGProps } from "react";
const SvgBusinessChartAlternative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.25 10.916v2.333M9.75 8.584v4.667M6.25 5.666v7.583M2.75 2.75v10.5"
    />
  </svg>
);
export default SvgBusinessChartAlternative;
